import { captureEvent } from '../../../services/event-capture';

export type ChangeEmailStep =
  | 'settings'
  | 'intro'
  | 'reauth waiting'
  | 'reauth landing'
  | 'form'
  | 'confirm landing';

export type ChangeEmailAction =
  | 'link clicked'
  | 'view'
  | 'back'
  | 'close'
  | 'continue'
  | 'start again'
  | 'back to settings'
  | 'send confirmation'
  | 'request reauth'
  | 'verify reauth'
  | 'request change'
  | 'confirm change';

type ChangeEmailEventPayload = {
  step: ChangeEmailStep;
  outcome?: 'success' | 'error';
};

export const trackChangeEmailEvent = (
  action: ChangeEmailAction,
  payload: ChangeEmailEventPayload,
) => {
  captureEvent({
    type: 'profile: change email',
    payload: {
      action,
      ...payload,
    },
    sendToAmplitude: true,
  });
};
